<template>
  <div class="achievements-banner">
    <div class="achievements-banner__content">
      <h2 class="achievements-banner__title">
        Получай достижения
        выигрывай призы
      </h2>
      <h6 class="achievements-banner__sub-title">
        Качественно выполненная работа быстро
      </h6>
      <p class="achievements-banner__text">
        Найдите подходящего фрилансера, чтобы начать
        работу над вашим проектом в течение нескольких
        минут.
      </p>
    </div>
    <div class="achievements-banner__items">
      <div class="achievements-banner-item">
        <img
          class="achievements-banner-item__image"
          src="/local/templates/main/images/achievements/achievements-item.png"
          alt="achievements-item"
        >
        <p class="achievements-banner-item__text">
          Получи две секретные ачивки и получи
          Кружку и шопер
        </p>
      </div>
      <div class="achievements-banner-item">
        <img
          class="achievements-banner-item__image"
          src="/local/templates/main/images/achievements/achievements-item.png"
          alt="achievements-item"
        >
        <p class="achievements-banner-item__text">
          Получи две секретные ачивки и получи
          Кружку и шопер
        </p>
      </div>
      <div class="achievements-banner-item">
        <img
          class="achievements-banner-item__image"
          src="/local/templates/main/images/achievements/achievements-item.png"
          alt="achievements-item"
        >
        <p class="achievements-banner-item__text">
          Получи две секретные ачивки и получи
          Кружку и шопер
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AchievementsBanner',
  props: ['result'],
}
</script>

<style lang="scss" scoped>
.achievements-banner {
  display: grid;
  grid-template-columns: 461px 1fr;
  grid-gap: 41px;
  margin: 149px 0 172px;
  background: #F6F6F8;
  border-radius: 6px;
  padding: 33px 21px 64px 68px;
  @include tablet{
    grid-template-columns: 1fr;
    padding: 33px;
    margin: 62px 0;
  }
  &__content{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &__title{
    margin: 0 0 37px;
  }
  &__sub-title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    color: #000000;
    @include tablet{
      font-size: 16px;
      line-height: 26px;
    }
  }
  &__text{
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 0;
    @include tablet{
      font-size: 14px;
      line-height: 24px;
    }
  }
  &__items{
    display: grid;
    grid-gap: 46px;
    grid-template-columns: repeat(3, 1fr);
    @include mobile{
      grid-template-columns: 1fr;
    }
  }
}
.achievements-banner-item{
  &__image{
    display: block;
    margin-bottom: 8px;
  }
  &__text{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    color: #252425;
    margin-bottom: 0;
  }
}
</style>